/** Audience de la API de matrículas solicitada en userinfo (sin prefijo api://). */
export const MATRICULAS_API_AUDIENCE = 'matriculas.api.utamed.es';

/** Audience de la API de financiero solicitada en userinfo (sin prefijo api://). */
export const FINANCIERO_API_AUDIENCE = 'financiero.api.utamed.es';

/** Scopes de permisos de la API de matrículas. */
export const MATRICULAS_SCOPE_READ = 'matriculas:read';
export const MATRICULAS_SCOPE_WRITE = 'matriculas:write';
/** Reactivar matrículas/preinscripciones dadas de baja. No implica `matriculas:write`. */
export const MATRICULAS_SCOPE_REACTIVATE = 'matriculas:reactivate';

/** Scopes de permisos de la API de financiero. */
export const FINANCIERO_SCOPE_READ = 'financiero:read';
export const REMESAS_SCOPE_WRITE = 'remesas:write';
/** Acciones sobre TPV y lotes de TPV (ejecutar, cancelar, marcar erróneo...). */
export const TPV_SCOPE_WRITE = 'tpv:write';
/** Crear el lote de TPV del día. */
export const LOTES_TPV_SCOPE_WRITE = 'lotes-tpv:write';

/** Scopes reconocidos por la aplicación (el resto se descarta al extraer userinfo). */
export const KNOWN_SCOPES = [
  MATRICULAS_SCOPE_READ,
  MATRICULAS_SCOPE_WRITE,
  MATRICULAS_SCOPE_REACTIVATE,
  FINANCIERO_SCOPE_READ,
  REMESAS_SCOPE_WRITE,
  TPV_SCOPE_WRITE,
  LOTES_TPV_SCOPE_WRITE,
] as const;

/** Query param para avisar en login de falta de permisos de acceso a la app. */
export const LOGIN_MISSING_PERMISSIONS_REASON = 'missing_permissions';

export type RequiredScopesMode = 'any' | 'all';
export type RequiredScopes = {
  scopes: string[];
  mode?: RequiredScopesMode;
};

/** Basta con poder leer una de las dos APIs para entrar en la app. */
export const APP_ACCESS_REQUIRED_SCOPES: RequiredScopes = {
  scopes: [MATRICULAS_SCOPE_READ, FINANCIERO_SCOPE_READ],
  mode: 'any',
};

export const MATRICULAS_SECTION_REQUIRED_SCOPES: RequiredScopes = {
  scopes: [MATRICULAS_SCOPE_READ],
  mode: 'all',
};

export const FINANCIERO_SECTION_REQUIRED_SCOPES: RequiredScopes = {
  scopes: [FINANCIERO_SCOPE_READ],
  mode: 'all',
};

export function hasRequiredScopes(userScopes: string[] | undefined, required: RequiredScopes | undefined): boolean {
  if (!required || required.scopes.length === 0) {
    return true;
  }

  const availableScopes = userScopes ?? [];
  if (required.mode === 'any') {
    return required.scopes.some((scope) => availableScopes.includes(scope));
  }

  return required.scopes.every((scope) => availableScopes.includes(scope));
}
